import { render, staticRenderFns } from "./StakingProgress.vue?vue&type=template&id=74d48b3e&scoped=true"
import script from "./StakingProgress.vue?vue&type=script&lang=js"
export * from "./StakingProgress.vue?vue&type=script&lang=js"
import style0 from "./StakingProgress.vue?vue&type=style&index=0&id=74d48b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d48b3e",
  null
  
)

export default component.exports